import { RegionType } from "graphql/generated";

export const SORT_VALUE = {
  CONDITIONS: "conditions",
  PRESCRIPTION_SUPPLEMENTS: "prescription_supplements",
  SUPPLEMENTS_PRESCRIPTION: "supplements_prescription",
  ALPHABETICAL: "alphabetical",
  PRICE_LOW_HIGH: "price_low_high",
  PRICE_HIGH_LOW: "price_high_low"
};

export const CATEGORIES = ["all", "sex", "hair", "skin", "wellbeing", "mental_health", "fertility"];

export const NOAH_MENU_ITEMS = {
  [RegionType.Sg]: [
    { text: "menu-all", value: "all" },
    { text: "menu-sexual-health", value: "sex" },
    // { text: "menu-hair", value: "hair" },
    // { text: "menu-skin", value: "skin" },
    { text: "menu-wellbeing", value: "wellbeing" }
    // { text: "menu-mental-health", value: "mental_health" },
  ],
  [RegionType.Hk]: [
    { text: "menu-all", value: "all" },
    { text: "menu-sexual-health", value: "sex" },
    { text: "menu-hair", value: "hair" },
    // { text: "menu-skin", value: "skin" },
    { text: "menu-wellbeing", value: "wellbeing" }
    // { text: "menu-mental-health", value: "mental_health" },
  ],
  [RegionType.Jp]: [
    { text: "menu-all", value: "all" },
    { text: "menu-sexual-health-jp", value: "sex" },
    { text: "menu-hair-jp", value: "hair" }
    // { text: "menu-skin", value: "skin" },
    // { text: "menu-wellbeing", value: "wellbeing" }
    // { text: "menu-mental-health", value: "mental_health" },
  ]
};
export const MENU_ITEMS = (platform = "noah") =>
  platform.toLowerCase() === "noah"
    ? NOAH_MENU_ITEMS[process.env.NEXT_PUBLIC_COUNTRY]
    : [
        { text: "menu-all", value: "all" },
        { text: "menu-sexual-health", value: "sex" },
        { text: "menu-fertility", value: "fertility" },
        // { text: "menu-hair", value: "hair" },
        { text: "menu-skin", value: "skin" },
        { text: "menu-wellbeing", value: "wellbeing" }
        // { text: "menu-mental-health", value: "mental_health" },
      ];
